/**
* @description: 提交记录列表
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch" />
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight" :maxPage="maxPage"
                @pageChange="pageChange" @limitChange="limitChange">
                <template #status="{ row }">
                    {{ listToMap(statusOptions, {})[row.status] }}
                </template>
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button  class="opBtn" size="small" type="primary" link
                            @click="openAudit(scope.row)" v-if="scope.row.status === 1">{{ t('taskSpecial.auditTask') }}</el-button>
                            <el-button v-if="scope.row.status > 1" class="opBtn" size="small" type="primary" link
                                @click="openDetail(scope.row)">{{ t('common.detail') }}</el-button>
                    </div>
                </template>
            </hc-table>
        </div>
        <!-- 新增 -->
        <!-- 审核 -->
        <Audit ref="audit" :title="t('taskSpecial.auditTask')" @refresh="getSearch(searchData)" />

        <!-- 详情 -->
        <Detail ref="detail"  />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, onActivated, toRaw } from "vue";
import Audit from "./components/audit.vue";
import Detail from "./components/detail.vue"

import { pageListApi as taskListApi } from "@/api/task/special.js";
import { pageListApi } from "@/api/task/submitRecord.js";
import { listToMap } from "@/utils/utils";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyTaskSubmitLabels } from "@/utils/taskSubmitI18n.js";
const myElementRef = ref();
const searchBox = ref();
const audit = ref();
const detail = ref()


let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const statusOptions = reactive([
    { label: "未提交", value: 0 },
    { label: "待审核", value: 1 },
    { label: "审核通过", value: 2 },
    { label: "审核不通过", value: 3 }
])


const state = reactive({
    title: "",
    column: [
        {
            prop: "id",
            show: false,
            label: "记录ID",
        },
        {
            // prop: "id",
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },
        {
            prop: "title",
            show: true,
            label: "任务名称",
            width: 200,
        },
        {
            prop: "real_name",
            show: true,
            label: "提交人姓名",
        },
        {
            prop: "username",
            show: true,
            label: "提交人用户名",
        },
        {
            prop: "mobile",
            show: true,
            label: "提交人手机",
        },
        {
            prop: "created_at",
            show: true,
            label: "创建时间",
        },
        {
            prop: "updated_at",
            show: true,
            label: "更新时间",
        },
        {
            prop: "status",
            show: true,
            label: "状态",
        },
        {
            prop: "operation",
            show: true,
            label: "操作",
        },
    ],
    offsetHeight: 0,
    tableHeader: [],
    tableData: [
        // {
        //     "updated_at": "2025-05-09 15:02:01",
        //     "user_id": 1,
        //     "mobile": "13456214521",
        //     "created_at": "2025-05-09 15:02:01",
        //     "task_id": 1,
        //     "real_name": "张三",
        //     "id": 1,
        //     "replied_by": 0,
        //     "status": 0,
        //     "username": "jishou0001"
        // }
    ]
});

const applyLabels = () => {
    applyTaskSubmitLabels({ searchData, columns: state.column, statusOptions });
};
const { t } = usePageI18n(applyLabels);

const searchData = reactive([
    {
        label: "任务名称",
        type: "select",
        children: [],
        value: null,
        field: 'task_id'
    },
    {
        label: "关键词",
        type: "input",
        value: "",
        field: 'keywords'
    },
]);

const init = () => {
    getTaskList()
};

const getTaskList = () => {
    const requestParams = {
        "keywords": "",
        "page": 1,
        "limit": 9999
    }
    taskListApi(JSON.stringify(requestParams)).then(res => {
        if (res.code == 200) {
            searchData[0].children = res.data.map(i => {
                return {
                    ...i,
                    label: i.title,
                    value: i.id
                }
            }) ?? []
            // searchData[0].value = searchData[0].children[0].id
            getSearch(searchData)
        }
    })
}

// 动态改变表头
const change = (item) => {
    tableHeaderFn();
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {

    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {

    limit.value = currentLimit;
    getSearch(searchData)
}

const deleteRow = (row) => {

};

const openAudit = (row) => {
    audit.value.open(row)
}

const openDetail = (row) => {
    detail.value.open(row)
}

onMounted(() => {
    try {
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        applyLabels();
        tableHeaderFn();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

// 查询过来的数据
const getSearch = (params) => {
    const form = listToMap(toRaw(params), { value: 'value', key: 'field' })
    const requestParams = {
        page: page.value,
        limit: limit.value,
        ...form
    }
    state.loading = true
		pageListApi(JSON.stringify(requestParams)).then(res => {
        maxPage.value = res?.maxPage ?? 0;
        state.tableData = res?.data?.map(item => {
            return {
                ...item,
                // status: listToMap(statusOptions, {})[item.status],
            }
        }) ?? []
    }).finally(() => {
		state.loading = false
	})
};

// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    // margin: 0 !important;
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
